import { uniq } from "ramda";
import * as React from "react";

const KEY = "search_history";

type UseSearchLocationHistoryReturn = {
  loadedValues: Array<string>;
  saveNewLocation: (newValue: string) => void;
  removeFromHistory: (location: string) => void;
};

const useSearchLocationHistory = (): UseSearchLocationHistoryReturn => {
  const [loadedValues, setValues] = React.useState<
    UseSearchLocationHistoryReturn["loadedValues"]
  >(() => {
    const data =
      typeof window === "undefined" ? null : localStorage.getItem(KEY);

    if (!data) {
      return [];
    }

    const parsedArray = JSON.parse(data);

    if (
      !(
        Array.isArray(parsedArray) &&
        parsedArray.every((value) => typeof value === "string")
      )
    ) {
      localStorage.removeItem(KEY);

      return [];
    }

    return parsedArray;
  });

  const saveNewLocation: UseSearchLocationHistoryReturn["saveNewLocation"] = (
    newValue,
  ) => {
    setValues((prev) => {
      const newArray = uniq([newValue, ...prev]);

      localStorage.setItem(KEY, JSON.stringify(newArray));

      return newArray;
    });
  };

  const removeFromHistory: UseSearchLocationHistoryReturn["saveNewLocation"] = (
    location,
  ) => {
    setValues((prev) => {
      const newArray = prev.filter((prevLocation) => prevLocation !== location);

      localStorage.setItem(KEY, JSON.stringify(newArray));

      return newArray;
    });
  };

  return { loadedValues, saveNewLocation, removeFromHistory };
};

export default useSearchLocationHistory;
